import  Todo  from "./components/Todo";
// import "./App.css";

function App() {
  return (
    <div className="outterScreen">
      <div className="App">
          <Todo  /> 
       </div>
    </div>
  );
}

export default App;
